import React from 'react';
import { Drawer, Box, IconButton } from '@mui/material';
import { X } from 'lucide-react';
import SidebarMobileMenu from './sidebar-mobile-menu';

interface SidebarMobileDrawerProps {
    open: boolean;
    onClose: () => void;
}

const SidebarMobileDrawer: React.FC<SidebarMobileDrawerProps> = ({ open, onClose }) => {
    return (
        <Drawer
            anchor="left"
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    width: 250,
                    background: 'background.paper',
                }
            }}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', position: 'relative' }}>
                {/* Close button */}
                <Box sx={{ position: 'absolute', right: 8, top: 8, zIndex: 10 }}>
                    <IconButton size="small" onClick={onClose}>
                        <X size={20} />
                    </IconButton>
                </Box>

                {/* Mobile sidebar menu content */}
                <Box sx={{ flex: 1, overflowY: 'auto', mt: 5, pt: 0 }}>
                    <SidebarMobileMenu onNavigate={onClose} />
                </Box>
            </Box>
        </Drawer>
    );
};

export default SidebarMobileDrawer;
